export type Options = {
  [key: string]: string;
};

export const mapOptionsToSelect = (options: Options) =>
  Object.entries(options).map(([key, value]: [key: string, value: string]) => ({
    value: key,
    label: value,
  }));
